#import "./AddressFull.graphql"
#import "./PaymentFull.graphql"
#import "./OrderPricesFull.graphql"
#import "./OrderProductFull.graphql"
#import "./FakturoidDataFull.graphql"
#import "./GoPayDataFull.graphql"

fragment PublicOrderFull on PublicOrder {
  b2cDetailId
  billingAddress {
    ...AddressFull
  }
  createdAt
  couponCode
  deliveryAddress {
    ...AddressFull
  }
  deliveryType
  fakturoidData {
    ...FakturoidDataFull
  }
  goPayData {
    ...GoPayDataFull
  }
  legacyOrderId
  locale
  modifiedAt
  orderNumber
  paidAt
  payment {
    ...PaymentFull
  }
  prices {
    ...OrderPricesFull
  }
  products {
    ...OrderProductFull
  }
  status
}
